import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS} from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { ProformaService } from '../../../services/operaciones/proforma/proforma.service';
import { LoginService } from 'app/services/login/login.service';
import Swal from "sweetalert2";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-listado-documentos-asociados',
  templateUrl: './listado-documentos-asociados.component.html',
  styleUrls: ['./listado-documentos-asociados.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class ListadoDocumentosAsociadosComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_Proforma=environment.LABEL_PROFORMA;
  Label_id_soles=environment.ID_GUIA_SOLES;
  proformas : any = [];
  ruc = new FormControl();
  rucAdq = new FormControl();
  readonly TIPO_OPERACION = 'PR';
  idProv ="" ;
  idAdq ="";
  RUC_PROV : string;
  RUC_ADQ : string;
  Canal : string = "B";
  FFinal : Date = new Date();
  FInicial  : Date = new Date();
  filteredProveeedor: Observable<any[]>;
  proveedoresArr;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  docNegociables:any = [];
  loading:boolean;
  dataSource :any; 

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];

  displayedColumns: string[] = ['checked','NombreComercialProv','NombreComercialAdq','TipoMoneda','VNPP','Cantidad'];
 
  constructor(private proformaService:ProformaService, private router:Router,private loginService:LoginService) { }

  ngOnInit() { 
    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();
    this.ListadoProformaFiltros();
  }

  ListadoProformaFiltros(){
    this.loading = true;

    if (this.ruc.value == ''){
      this.idProv = '';
    }
    if (this.rucAdq.value == ''){
      this.idAdq = '';
    }

    this.proformaService.ObtenerListaProforma(this.idProv, this.idAdq, this.TIPO_OPERACION).subscribe(
      res => {
        this.proformas = res;    
        this.dataSource = new MatTableDataSource(this.proformas);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      } , err =>{
        this.loading = false;
        Swal.fire({
          title: "Registrar tipo de cambio",
          text: "Coordinar con el área de contabilidad",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    )
  }

  obtenerRucRazSocialAdq(termino :string = ''){
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
      for( let p of this.adquirentessArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.idAdq = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  obtenerRucRazSocialProv(termino :string = ''){ 
    if (termino != null && termino != ''){  
      let termino1 = termino.toLowerCase();                   
      for( let p of this.proveedoresArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
          this.idProv = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));

      this.filteredProveeedor = this.ruc.valueChanges.pipe(
        startWith(""),
        map(state =>
            state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerAdquirentesCombo() {
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges.pipe(
      startWith(""),
      map(state =>
          state ? this._filterAdq(state) : this.adquirentessArr.slice()
      )
    );
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerRucProv(termino :string){
    this.idProv = termino;
  }
  
  obtenerRucAdq(termino :string){
    this.idAdq = termino;
  }

  crearProforma(elemento : any){
       this.loginService.clickGuard = true;
      this.proformaService.datosProforma = elemento;
      this.router.navigate(["/operaciones/proformas/nuevo"]);
  }
}
